import { Badge, Card, followUpTone, Icon } from '../../components';
import { useI18n } from '../../lib/i18n';
import { Link } from '../../lib/router';
import type { PackSite } from '../../lib/api/types';

export function DueBadge({ days }: { days: number | null | undefined }) {
  const { t } = useI18n();
  if (days === null || days === undefined) return null;
  return (
    <Badge tone={followUpTone(days)} icon="clock">
      {days < 0 ? t('ui.sites.overdueBy', { count: -days }) : t('ui.sites.dueIn', { count: days })}
    </Badge>
  );
}

export function SiteCard({ site, onlineOnly }: { site: PackSite; onlineOnly?: boolean }) {
  const { t } = useI18n();
  const due = site.enrolments?.find((e) => e.surveyType === 'SSS') ?? site.enrolments?.[0];
  return (
    <Link to={`/sites/${site.id}`}>
      <Card interactive className="flex items-center gap-3.5 p-4">
        <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-brand/15 bg-brand-soft text-brand">
          <Icon name="building" size={20} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold">{site.name}</p>
          <p className="truncate text-sm text-muted">
            {[site.customerName, site.code, site.serviceLine].filter(Boolean).join(' · ')}
          </p>
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            <DueBadge days={due?.daysToFollowUp} />
            {onlineOnly && <Badge tone="info">{t('ui.sites.onlineOnly')}</Badge>}
          </div>
        </div>
        <Icon name="chevronRight" className="text-muted rtl:rotate-180" />
      </Card>
    </Link>
  );
}
